__turbopack_context__.v({
  "actionButton": "CandidateCardProfile-module__XhlSca__actionButton",
  "actionIcon": "CandidateCardProfile-module__XhlSca__actionIcon",
  "actions": "CandidateCardProfile-module__XhlSca__actions",
  "avatarBlurred": "CandidateCardProfile-module__XhlSca__avatarBlurred",
  "avatarImage": "CandidateCardProfile-module__XhlSca__avatarImage",
  "avatarWrapper": "CandidateCardProfile-module__XhlSca__avatarWrapper",
  "body": "CandidateCardProfile-module__XhlSca__body",
  "cta": "CandidateCardProfile-module__XhlSca__cta",
  "description": "CandidateCardProfile-module__XhlSca__description",
  "footer": "CandidateCardProfile-module__XhlSca__footer",
  "header": "CandidateCardProfile-module__XhlSca__header",
  "headerText": "CandidateCardProfile-module__XhlSca__headerText",
  "locationChip": "CandidateCardProfile-module__XhlSca__locationChip",
  "locationIcon": "CandidateCardProfile-module__XhlSca__locationIcon",
  "name": "CandidateCardProfile-module__XhlSca__name",
  "root": "CandidateCardProfile-module__XhlSca__root",
  "skillChip": "CandidateCardProfile-module__XhlSca__skillChip",
  "skills": "CandidateCardProfile-module__XhlSca__skills",
  "title": "CandidateCardProfile-module__XhlSca__title",
});
